import {Component, OnInit} from '@angular/core';
import {HttpService} from '../../../services/http.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { EditPreferencesDialogComponent } from '../edit-preferences-dialog/edit-preferences-dialog.component';
import { SubscribeDialogComponent } from '../subscribe-dialog/subscribe-dialog.component';


@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

    constructor(private httpService: HttpService, private dialog: MatDialog, private router: Router,  private route: ActivatedRoute) {}

    ngOnInit(): void {
      this.route.queryParams.subscribe(params => {
        const inscribirse = params['inscribirse'];
        if (inscribirse === 'boletin-quincenal') {
          this.dialog.open(SubscribeDialogComponent, {
            width: '500px',
            data: { plan: inscribirse }  // si quieres pasar el valor al modal
          });
        }
      });
    }


    
  openDialog() {
    const dialogRef = this.dialog.open(EditPreferencesDialogComponent, {
      width: '350px',
      data: {preferences: true},
      panelClass: 'custom-modalbox',
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.subscriber) {
        this.router.navigate(['/edit_confirmation']);
      }
    });
  }

  showPreferencesModal( values: any ): void {
    setTimeout(() => {
        const dialogRef = this.dialog.open(EditPreferencesDialogComponent, {
            width: '350px',
            data: {preferences: true},
            panelClass: 'custom-modalbox',
            autoFocus: false
          });
      
          dialogRef.afterClosed().subscribe((result: any) => {
            if (result && result.subscriber) {
              this.router.navigate(['/edit_confirmation']);
            }
          });
    }, 200);
  }
}
